import { createReducer, on } from '@ngrx/store';
import { notesCloseModal, notesOpenModalSuccess } from './notes.actions';

export interface NotesState {
  isNoteModalOpened: boolean;
}

export const initialState: NotesState = {
  isNoteModalOpened: false,
};

export const notesReducer = createReducer(
  initialState,
  on(notesOpenModalSuccess, (state) => ({
    ...state,
    isNoteModalOpened: true,
  })),
  on(notesCloseModal, (state) => ({
    ...state,
    isNoteModalOpened: false,
  })),
);
